import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { adminOidcConfigurationsByCustomerReducers, adminOidcConfigurationsByCustomerWatchers } from './by-customer';

export const adminOidcConfigurationsReducers = combineReducers({
	byCustomer: adminOidcConfigurationsByCustomerReducers
});

export const adminOidcConfigurationsWatchers = combineAllWatchers([
	adminOidcConfigurationsByCustomerWatchers
]);
